import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
    providedIn: 'root'
})
export class JwtService {
    private jwtHelper: JwtHelperService;

    constructor() {
        this.jwtHelper = new JwtHelperService();
    }

    public decodeToken(token: string): any {
        return this.jwtHelper.decodeToken(token);
    }

    public getClaim(token: string, claimKey: string): any {
        const decodedToken = this.decodeToken(token);
        return decodedToken ? decodedToken[claimKey] : null;
    }

    saveToken(token: string) {
        localStorage.setItem('id_token', token);
    }

    getToken(): string | null {
        return localStorage.getItem('id_token');
    }

    removeToken() {
        localStorage.removeItem('id_token');
    }

    saveAccessToken(token: string) {
        localStorage.setItem('access_token', token);
    }

    getAccessToken(): string | null {
        return localStorage.getItem('access_token');
    }

    removeAccessToken() {
        localStorage.removeItem('access_token');
    }
}